import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Box, Card, Flex, Heading, Text } from "@radix-ui/themes";
import type React from "react";
import { useTranslation } from "react-i18next";

import { getColor } from "@themes/colors";

import EkidenLogo from "../../assets/icons/logo-circle.svg?react";
import { maintenanceConfig } from "../../config/maintenance";

export const Maintenance: React.FC = () => {
  const { t } = useTranslation();
  return (
    <MaintenanceContainer>
      <Card size="4" style={{ maxWidth: "600px", textAlign: "center" }}>
        <Flex align="center" direction="column" gap="6">
          <AnimatedLogoContainer>
            <EkidenLogo />
            <PulseRing />
            <PulseRing delay={0.5} />
            <PulseRing delay={1} />
          </AnimatedLogoContainer>

          <Flex align="center" direction="column" gap="3">
            <Heading color="gray" size="6">
              {t("maintenance.title")}
            </Heading>

            <Text color="gray" size="3" style={{ lineHeight: 1.6 }}>
              {maintenanceConfig.maintenanceMessage}
            </Text>
          </Flex>

          {maintenanceConfig.estimatedDuration && (
            <Box>
              <Text color="gray" size="3">
                {maintenanceConfig.estimatedDuration}
              </Text>
            </Box>
          )}

          <Flex align="center" direction="column" gap="2">
            <Text color="gray" size="2">
              {t("maintenance.message")}
            </Text>
          </Flex>
        </Flex>
      </Card>
    </MaintenanceContainer>
  );
};

const MaintenanceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background: ${getColor("gray-1")};
`;

const pulse = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.3;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
`;

const AnimatedLogoContainer = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2);
    z-index: 2;
  }
`;

const PulseRing = styled.div<{ delay?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  border: 2px solid ${getColor("accent-9")};
  border-radius: 50%;
  animation: ${pulse} 2s ease-out infinite;
  animation-delay: ${({ delay = 0 }) => delay}s;
`;
